import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { ModalInterface } from "app/interface/modal";
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-confirm-insured-trip-cancelation',
    templateUrl: './confirm-insured-trip-cancelation.component.html',
    styleUrls: ['./confirm-insured-trip-cancelation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmInsuredTripCancelationComponent implements AfterViewInit, OnInit, ModalInterface {

  @ViewChild('ConfirmInsuredTripCancelation') modalTemplateRef: TemplateRef<any>;
  initiator: BehaviorSubject<boolean>;
  modalDialogRef: NxModalRef<any, any>;
  confirm: BehaviorSubject<SubmitEvent>;

  confirmForm: FormGroup;

  constructor(
    protected dialogService: NxDialogService,
  ) {
    this.initiator = new BehaviorSubject(false);
    this.confirm = new BehaviorSubject(null);
   }


  openModal(): void {
    this.modalDialogRef = this.dialogService.open(this.modalTemplateRef, { showCloseIcon: true, width: '442px' });
  }

  closeModal(): void {
    this.modalDialogRef.close();
  }

  ngAfterViewInit(): void {
    this.initiator.next(true);
  }

  ngOnInit(): void {
    this.confirmForm = new FormGroup({});
  }

  submitConfirmation($event: SubmitEvent) {
    this.modalDialogRef.close();
    this.confirm.next($event);
  }

  inputData(inputData?: any): void {
    //throw new Error('Method not implemented.');
  }
}
